/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeliveryEventEnum } from './deliveryEventEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface DeliveryEvent { 
    type: DeliveryEventEnum;
    at: string;
}
export namespace DeliveryEvent {
}

export const DeliveryEvent_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DeliveryEvent_at_Validators: ValidatorFn[] =
    [  Validators.required, ];


